<template>
  <vue-date-time
    input-class="input"
    v-bind="$attrs"
    :value="valueISO"
    @input="inputHandler"
  >
  </vue-date-time>
</template>

<script>
import { Datetime as VueDateTime } from 'vue-datetime';
import { DateTime as LuxonDateTime } from 'luxon';

import { Timestamp } from '../../firebase';

export default {
  props: {
    value: {
      default: null,
      type: Timestamp
    }
  },
  computed: {
    valueISO() {
      return this.value
        ? LuxonDateTime.fromJSDate(this.value.toDate()).toISO()
        : this.value;
    }
  },
  methods: {
    inputHandler(newValue) {
      this.$emit('input', Timestamp.fromDate(new Date(newValue)));
    }
  },
  components: {
    VueDateTime
  },
  inheritAttrs: false
};
</script>

<style></style>
